import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { IGetVillageListResponseSchema } from '../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { getVillageList } from '../../api/get_village_list';
import { IThunkActionCreator } from '../../types/store';
import { fetchFinished, fetchStarted } from '../is_fetching/actions';
import { changeRoadsSavedFilter } from '../roads/changeRoadsSavedFilter';
import { changeStationsSavedFilter } from '../stations/actions';
import { trackPageView } from '../../utils/analytics';

export enum ActionTypes {
  Fetched = 'IVillageListFetched',
  FetchError = 'IVillageDataFetchError',
  MobileFetched = 'IMobileVillageListFetched',
}

export interface IVillageListFetched {
  data: IGetVillageListResponseSchema;
  type: ActionTypes.Fetched;
}

export interface IMobileVillageListFetched {
  data: IGetVillageListResponseSchema;
  type: ActionTypes.MobileFetched;
}

export interface IVillageDataFetchError {
  type: ActionTypes.FetchError;
  error: string;
}

export const onVillageListFetched = (data: IGetVillageListResponseSchema): IVillageListFetched => ({
  data,
  type: ActionTypes.Fetched,
});

export const onMobileVillageListFetched = (data: IGetVillageListResponseSchema): IMobileVillageListFetched => ({
  data,
  type: ActionTypes.MobileFetched,
});

export const onVillageListFetchError = (error: string): IVillageDataFetchError => ({
  error,
  type: ActionTypes.FetchError,
});

export type Action = IVillageListFetched | IVillageDataFetchError | IMobileVillageListFetched;

export function clearVillageList(parameters: IGetVillageListRequestSchema): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch(fetchStarted());

    return getVillageList(context.httpApi, context.logger, parameters)
      .then((response: IGetVillageListResponseSchema) => {
        dispatch(
          onVillageListFetched({
            ...response,
            totalItems: 0,
            totalPages: 0,
            villageList: [],
          }),
        );
      })
      .catch(error => {
        dispatch(onVillageListFetchError(error.message));
      })
      .then(() => {
        dispatch(fetchFinished());
        dispatch(changeRoadsSavedFilter());
        dispatch(changeStationsSavedFilter());
      });
  };
}

export function fetchVillageList(parameters?: IGetVillageListRequestSchema, isMobile?: boolean): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch(fetchStarted());
    const filters: IGetVillageListRequestSchema = parameters || getState().filters;

    return getVillageList(context.httpApi, context.logger, filters)
      .then((response: IGetVillageListResponseSchema) => {
        dispatch(isMobile ? onMobileVillageListFetched(response) : onVillageListFetched(response));
        trackPageView(getState());
      })
      .catch(error => {
        dispatch(onVillageListFetchError(error.message));
      })
      .then(() => {
        dispatch(fetchFinished());
        dispatch(changeRoadsSavedFilter());
        dispatch(changeStationsSavedFilter());
      });
  };
}
